import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, Button, Card, Input } from '../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../services/ContainerService';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { formatDate, showMessageToastCustom, translate } from '../../../../utils/util';
import ModalUpload from './ModalUpload';
import ConfirmModalUI from '../../../../components/UI/ConfirmModalUI';

const CriticalPartInsert = (props) => {
    const [openModal, setOpenModal] = useState(false);
    const [criticalPart, setCriticalPart] = useState(props.location?.state?.update && props.criticalPart ? props.criticalPart : { code: ""});
    const [pnNotFound, setPnNotFound] = useState(false);
    const [isValidPN, setIsValidPN] = useState(false);
    const update = props.location?.state?.update;

    useEffect(() => {
        if (props.location?.state?.update && props.criticalPart) {
            setCriticalPart({ ...props.criticalPart,
                criticalityDate: formatDate(props.criticalPart.criticalityDate),
                openingTime: props.criticalPart.openingTime?.substring(0,5)
            });
            setIsValidPN(true);
        }
    // eslint-disable-next-line
    }, [props.location?.state?.update, props.criticalPart]);

    const onChange = (event) => {
        onValueChange(event, criticalPart, setCriticalPart);
    };

    const onConfirm = () => {
        if (validateInputsRequired())
        {
            if (!isValidPN) {
                setPnNotFound(true);
            }
            else if (criticalPart.id > 0) {
                props.update(criticalPart, (response) => {
                    if (response) {
                        showMessageToastCustom(translate('info', 'general'), translate('success', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            }
            else {
                props.insert(criticalPart, (response) => {
                    if (response) {
                        showMessageToastCustom(translate('info', 'general'), translate('success', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const validatePN = () => {
        setCriticalPart({...criticalPart, description: ""});
        
        props.getPartNumberDescription(criticalPart.partNumberCode, (res) => {
            if ((res.partNumberDescription ?? "") !== "")
            {
                setIsValidPN(true);
                setCriticalPart({...criticalPart, partNumberDescription: res.partNumberDescription});
            }
            else setPnNotFound(true);
        });
    }

    return (
        <div>
            <Breadcrumbs id="criticalPartInsert" title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('config.critical-parts-registration.add-critical-parts', 'container') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div className="row">
                            <div className="input-field no-padding col s12">
                                <Input
                                    required
                                    maxLength="11"
                                    label={translate('config.critical-parts-registration.partNumber', 'container')}
                                    id="partNumberCode"
                                    name="partNumberCode"
                                    type="text"
                                    disabled={update}
                                    onChange={onChange}
                                    onBlur={() => { setIsValidPN(false); validatePN(); }}
                                    defaultValue={criticalPart?.partNumberCode} />
                            </div>
                            
                            <div className="input-field no-padding col s12">
                                <Input
                                    label={translate('config.critical-parts-registration.partNumberDescription', 'container')}
                                    id="partNumberDescription"
                                    name="partNumberDescription"
                                    type="text"
                                    disabled
                                    icon="mdi mdi-information"
                                    value={criticalPart?.partNumberDescription} />
                            </div>
                            
                            <div className="input-field no-padding col s12">
                                <Input
                                    required
                                    maxLength="8"
                                    label={translate('config.critical-parts-registration.quantity', 'container')}
                                    id="quantity"
                                    name="quantity"
                                    type="text"
                                    numericOnly="true"
                                    onChange={onChange}
                                    value={criticalPart?.quantity} />
                            </div>
                            
                            <div className="input-field no-padding col s6">
                                <Input
                                    required
                                    label={translate('config.critical-parts-registration.criticalityDate', 'container')}
                                    id="criticalityDate"
                                    name="criticalityDate"
                                    type="date"
                                    onChange={onChange}
                                    defaultValue={criticalPart?.criticalityDate} 
                                    value={criticalPart?.criticalityDate} />
                            </div>
                            
                            <div className="input-field no-padding col s5">
                                <Input
                                    required
                                    label={translate('config.critical-parts-registration.openingTime', 'container')}
                                    id="openingTime"
                                    name="openingTime"
                                    type="time"
                                    onChange={onChange}
                                    value={criticalPart?.openingTime} />
                            </div>
                            
                            <div className="input-field no-padding col s12">
                                <Input
                                    type="text"
                                    required
                                    maxLength="40"
                                    label={translate('config.critical-parts-registration.observation', 'container')}
                                    id="observation"
                                    name="observation"
                                    onChange={onChange}
                                    value={criticalPart?.observation} />
                            </div>
                            
                            <div className="input-field no-padding col s12">
                                <Input
                                    type="checkbox"
                                    label={translate('config.critical-parts-registration.alwaysCritical', 'container')}
                                    id="alwaysCritical"
                                    name="alwaysCritical"
                                    onChange={onChange}
                                    defaultChecked={criticalPart?.alwaysCritical}
                                    value={criticalPart?.alwaysCritical} />
                            </div>
                        </div>

                        {!update &&
                        <div className="row">
                            <div className="input-field no-padding  col s1">
                                <button
                                    className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                    type="button"
                                    onClick={() => setOpenModal(true)}>
                                    <i className="Small material-icons">cloud_upload</i>
                                </button>
                            </div>
                        </div>}

                        <div className="row">
                            <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                        </div>
                    </Card>
                </div>
            </div>
            <ModalUpload
                open={openModal}
                id="ModalUpload"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />

            <ConfirmModalUI
                  open={pnNotFound}
                  id="modalNotExists"
                  data={{ title: translate('validations:attention'), message: translate('config.critical-parts-registration.part-number-not-found', 'container') }}
                  onConfirm={() => setPnNotFound(undefined)}
                  onClose={() => setPnNotFound(undefined)}
                  showCancel={false}
                  btnConfirm="OK"
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        criticalPart: state.containerReducer.criticalPart,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        insert: (item, callback) => {
            dispatch(ContainerService.insertCriticalPart(item, callback));
        },
        update: (item, callback) => {
            dispatch(ContainerService.updateCriticalPart(item, callback));
        },
        getPartNumberDescription: (item, callback) => {
            dispatch(ContainerService.getPartNumberDescription(item, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CriticalPartInsert)));
